var map = {
	"./config.js": "dOCX",
	"./front.js": "t2nm",
	"./index.js": "YaEn",
	"./module-gm.js": "hwKe",
	"./module-main.js": "/Ij8",
	"./product.js": "SFnO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xooV";


//////////////////
// WEBPACK FOOTER
// ./src/router \.js$
// module id = xooV
// module chunks = 2